import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormUser } from './FormUser';
import { DeleteUser } from './DeleteUser';
import { UpdateRoles } from './UpdateRoles';
import { Dialog } from 'primereact/dialog';

export const ModalUser = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        id_helen_users, id_external, name, paternal_surname, maternal_surname, departaments, username, job, card_code, areas,
        handleInputChange, handleSelectValues, validaciones,
        saveCreate, saveUpdate, saveDelete,
        listRol, listRoles, saveUpdatePatient,
    } = props;

    return (
        <Dialog
            visible={modal} 
            onHide={toggle} 
            header={modalTitle} 
              headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            className="small-dialog"
        >

            {
                method === "create"
                    ?
                    <FormUser button='Guardar' {...{ toggle, loading, handleInputChange, handleSelectValues, name, paternal_surname, maternal_surname, job, card_code, departaments, username, validaciones, methodAction: saveCreate, areas }} />
                    :
                    (method === "update")
                        ?
                        <FormUser button={"Actualizar"} {...{ toggle, loading, handleInputChange, handleSelectValues, name, paternal_surname, maternal_surname, job, card_code, departaments, username, areas, validaciones, methodAction: saveUpdate, id_external, name, paternal_surname, maternal_surname, job, card_code, departaments, username, areas }} />
                        :
                        (method === "update_roles")
                            ?
                            <UpdateRoles
                                {
                                ...{
                                    toggle, loading, handleSelectValues,
                                    validaciones, saveUpdatePatient,
                                    name, listRol, listRoles,
                                }
                                }
                            />
                            :
                            <DeleteUser {...{ toggle, loading, username, name, paternal_surname, maternal_surname, saveDelete }} />
            }
        </Dialog>
    )
}
